
    import {useStore} from "@/store";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        name: string;
        date: string;
    }
    export default defineComponent({
        name: "detectMsg",
        setup() {
            let state: State = reactive({
                name: '',
                date: '',
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {reportDetectOrderVO} = data
                state.name = reportDetectOrderVO.detectManName;
                state.date = reportDetectOrderVO.reportGenDate;
            });
            return {
                state
            }
        }
    })
